import { type GenericFreedrawElement } from '..';
import { type GenericShape } from '../../../lib/shapes';
import { pointsToShape } from '../../../utils/shapes';

export const getFreedrawShape = (
  element: GenericFreedrawElement,
  simplify: boolean = false,
): GenericShape => {
  let points = element.points;

  // single point paths are not properly transformed into shapes,
  // so we add a second point with a small offset
  if (points.length === 1) {
    points = [...points, [points[0][0] + 0.001, points[0][1]]];
  }

  const path = pointsToShape(
    points,
    element.x,
    element.y,
    element.points.length === 1 ? undefined : element.bezierHandles,
    {
      isClosed: false,
      strokeWidth: element.strokeWidth,
      strokeCap: element.strokeCap,
      simplify,
    },
  );

  return { data: path, type: 'line' };
};
